<template>
  <div class="error-boundary">
    <slot v-if="!hasError" />
    <MaintenanceView v-else />
  </div>
</template>

<script>
import MaintenanceView from '../views/MaintenanceView.vue'
import { isFatalError, isExcludedComponent } from '../utils/maintenanceConfig.js'

export default {
  name: 'ErrorBoundary',
  components: {
    MaintenanceView
  },
  data() {
    return {
      hasError: false
    }
  },
  errorCaptured(err, instance, info) {
    console.error('Error captured in ErrorBoundary:', err, info)
    
    // Check jika component dikecualikan
    const componentName = instance?.$options?.name || ''
    if (isExcludedComponent(componentName)) {
      console.log('Error in excluded component, allowing normal handling')
      return true
    }
    
    // Hanya tangkap error yang benar-benar fatal berdasarkan konfigurasi
    if (isFatalError(err, info)) {
      console.warn('Fatal error detected in ErrorBoundary, showing maintenance')
      this.hasError = true
      return false
    }
    
    // Untuk error non-fatal, biarkan error handler normal yang menangani
    console.log('Non-fatal error, allowing normal handling')
    return true
  },
  watch: {
    $route() {
      // Reset error state when route changes
      this.hasError = false
    }
  }
}
</script>

<style scoped>
.error-boundary {
  width: 100%;
  height: 100%;
}
</style>